import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthenticationRoutingModule } from './authentication-routing.module';
import { GoogleComponent } from './google/google.component';
import { OtpComponent } from './otp/otp.component';
import { AuthSigninRegisterComponent } from './auth-signin-register/auth-signin-register.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { RegisterComponent } from './register/register.component';
import { AppleSigninComponent } from './apple-signin/apple-signin.component';
import { ParentalGateComponent } from './parental-gate/parental-gate.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    GoogleComponent,
    OtpComponent,
    AuthSigninRegisterComponent,
    RegisterComponent,
    AppleSigninComponent,
    ParentalGateComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AuthenticationRoutingModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    TranslateModule
  ],
  providers: [AuthService]
})
export class AuthenticationModule { }
